import { LocalStorage } from "#services/local-storage.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { getVersion } from "@carnegie-learning/common-utils";
import { SchoolsFidoService } from "@carnegie-learning/data-access-angular-passport";
import { first } from "rxjs";
import { CookieService } from "./cookie.service";
import { LaunchIntentService } from "./launch-intent.service";

@Injectable({ providedIn: 'root' })
export class VersionService {
    constructor(
        private schoolsFidoService: SchoolsFidoService,
        private router: Router,
        private cookieService: CookieService,
        private localStorage: LocalStorage,
        private launchIntentService: LaunchIntentService
    ) {}
    redirectToCorrectVersion() {
        if ((<any>window).buildNumber !== 'dev') {
            const schoolID = this.cookieService.get('CL_SCHOOL');
            const userProfile = this.localStorage.get("userProfile");
            const userProfileBackup = this.localStorage.get("userProfile_backup");
            const launchSchoolId = this.launchIntentService.getSchoolId();
            if (schoolID && schoolID !== '') {
                this.fidoSchoolVersionChecker(schoolID);
            } else if (launchSchoolId && launchSchoolId !== '') {
                // LTI launch: use school ID from launch context if cookie not set yet (first launch scenario)
                this.fidoSchoolVersionChecker(launchSchoolId);
            } else if (userProfile && userProfile.hasOwnProperty("schools") && userProfile.schools.length > 0) {
                // edge case: CL_SCHOOL is not set, check if profile exists
                this.fidoSchoolVersionChecker((userProfile.schools[0]));
            } else if (userProfileBackup) {
                // Student impersonation edge case, avoid version enforcement
            } else {
                this.router.navigate(["login/form"]);
            }
        }
    }

    fidoSchoolVersionChecker(schoolID: string) {
        this.schoolsFidoService.getSchool(schoolID)
            .pipe(first())
            .subscribe(
                schoolData => {
                    const defaultURL = (<any>window).passportHost;
                    let versionedURL = null;
                    let schoolVersion = "";

                    if (
                        schoolData && schoolData.vers
                    ) {
                        const productVersion  = schoolData.vers.find(application => application.includes('passport'));
                        if (productVersion ) {
                            schoolVersion = getVersion(productVersion);
                            versionedURL = defaultURL + '/' + schoolVersion;
                            if (!location.pathname.includes(schoolVersion)) {
                                window.location.replace(versionedURL + '/' + location.hash);
                            }
                        }
                    }
                },
            );
    }
}
